<div class="comments" *tuiLet="(selectComments$|async) as comments">
    <div class="swiper">
      <button (click)="index=index-1" [disabled]="index == 0 || comments?.length == 0">
        <tui-icon icon="@tui.chevron-left"></tui-icon>
      </button>
      <tui-carousel
        [draggable]="true"
        [(index)]="index"
      >
        @for(cmt of comments; track $index){
          <div *tuiItem class="swiper-slide d-flex flex-column gap-3">
            <div class="head d-flex align-items-start justify-content-between">
              <div class="left">
                <span class="name d-block">{{cmt.commentName}}</span>
                <span class="country d-block">{{cmt.commentCountry}}</span>
              </div>
              <div class="right">
                <span> 
                  {{cmt.commentNote}} <small>/10</small>
                </span>
              </div>
            </div>
            <tui-scrollbar class="body">
              <div class="content" [innerHTML]="cmt.commentTextPost">
              </div>
            </tui-scrollbar>
            <div class="footer d-flex align-items-center justify-content-between">
              <span class="logo" [class.b]="cmt.commentEngine == 'booking'" [class.t]="cmt.commentEngine == 'TripAdvisor'"></span>
              <span class="date">{{cmt.commentDateString}}</span>
            </div>
          </div>
        }
      </tui-carousel>
      <button (click)="index=index+1" [disabled]="index == comments?.length-1 || comments?.length == 0">
        <tui-icon icon="@tui.chevron-right"></tui-icon>
      </button>
    </div>
</div>